
import { ReactNode, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

interface MainLayoutProps {
  children?: ReactNode;
}

const SIDEBAR_WIDTH = 240;
const COLLAPSED_WIDTH = 70;

const MainLayout = ({ children }: MainLayoutProps) => {
  const [expanded, setExpanded] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  // Update isMobile state on window resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      if (mobile) {
        setExpanded(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initialize on mount

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Handler for sidebar toggle that will be passed to Sidebar component
  const handleSidebarToggle = (isExpanded: boolean) => {
    setExpanded(isExpanded);
  };

  return (
    <div className="min-h-screen flex bg-background">
      <Sidebar onToggle={handleSidebarToggle} />
      <main 
        className="flex-1 transition-all duration-300 pt-16 lg:pt-0"
        style={{ 
          marginLeft: isMobile 
            ? 0 
            : (expanded ? `${SIDEBAR_WIDTH}px` : `${COLLAPSED_WIDTH}px`)
        }}
      >
        <div className="container mx-auto p-6">
          {children || <Outlet />}
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
